import * as yup from 'yup'

export const RULE_TYPES = {
    identity: 'Direct match (no change)',
    strip_prefix: 'Remove a prefix',
    strip_suffix: 'Remove a suffix',
    normalize_whitespace: 'Ignore spaces',
    exception_list: 'Exceptions only',
}

export const RULE_TYPE_OPTIONS = Object.entries(RULE_TYPES).map(([value, label]) => ({ label, value }))

export const ruleTypeNeedsValue = ruleType => ['strip_prefix', 'strip_suffix'].includes(ruleType)

export const EMPTY_RULE = {
    brandName: '',
    supplierAccountCode: '',
    tecDocSupplierId: '',
    ruleType: 'identity',
    ruleValue: '',
    exampleSomoraPartNumber: '',
    exampleTecDocPartNumber: '',
    notes: '',
    active: true,
}

export const ruleSchema = yup.object().shape({
    brandName: yup.string().required('Enter the brand name.'),
    supplierAccountCode: yup
        .string()
        .nullable()
        .matches(/^\d*$/, 'A supplier account code is digits only, e.g. 00621.'),
    tecDocSupplierId: yup
        .number()
        .typeError('Enter the TecDoc brand number (DLNr).')
        .integer()
        .positive('Enter the TecDoc brand number (DLNr).')
        .required('Enter the TecDoc brand number (DLNr).'),
    ruleType: yup.string().required(),
    ruleValue: yup
        .string()
        .nullable()
        .when('ruleType', {
            is: ruleTypeNeedsValue,
            then: yup.string().nullable().required('Enter the prefix or suffix this rule removes.'),
        }),
})

const blankToNull = value => (typeof value === 'string' && value.trim() === '' ? null : value)

export const ruleForApi = values => ({
    brandName: values.brandName.trim(),
    supplierAccountCode: blankToNull(values.supplierAccountCode),
    tecDocSupplierId: parseInt(values.tecDocSupplierId, 10),
    ruleType: values.ruleType,
    ruleValue: ruleTypeNeedsValue(values.ruleType) ? blankToNull(values.ruleValue) : null,
    exampleSomoraPartNumber: blankToNull(values.exampleSomoraPartNumber),
    exampleTecDocPartNumber: blankToNull(values.exampleTecDocPartNumber),
    notes: blankToNull(values.notes),
    active: !!values.active,
})

export const ruleForForm = rule => ({
    ...EMPTY_RULE,
    ...rule,
    supplierAccountCode: rule.supplierAccountCode ?? '',
    ruleValue: rule.ruleValue ?? '',
    exampleSomoraPartNumber: rule.exampleSomoraPartNumber ?? '',
    exampleTecDocPartNumber: rule.exampleTecDocPartNumber ?? '',
    notes: rule.notes ?? '',
})

export const ruleLabel = rule =>
    `${rule.brandName} (${rule.supplierAccountCode ? `account ${rule.supplierAccountCode}` : 'no account'})`
